/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_No_Team_TitleInputs */

const en_team_no_team_title = /** @type {(inputs: Team_No_Team_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Team Yet`)
};

const es_team_no_team_title = /** @type {(inputs: Team_No_Team_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay equipo`)
};

const fr_team_no_team_title = /** @type {(inputs: Team_No_Team_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas encore d'équipe`)
};

const de_team_no_team_title = /** @type {(inputs: Team_No_Team_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch kein Team`)
};

const id_team_no_team_title = /** @type {(inputs: Team_No_Team_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum Ada Tim`)
};

/** @type {(inputs: Team_No_Team_TitleInputs) => LocalizedString} */
const ja_team_no_team_title = en_team_no_team_title;

/** @type {(inputs: Team_No_Team_TitleInputs) => LocalizedString} */
const zh_team_no_team_title = en_team_no_team_title;

/** @type {(inputs: Team_No_Team_TitleInputs) => LocalizedString} */
const ar_team_no_team_title = en_team_no_team_title;

/** @type {(inputs: Team_No_Team_TitleInputs) => LocalizedString} */
const it_team_no_team_title = en_team_no_team_title;

/** @type {(inputs: Team_No_Team_TitleInputs) => LocalizedString} */
const ru_team_no_team_title = en_team_no_team_title;

/** @type {(inputs: Team_No_Team_TitleInputs) => LocalizedString} */
const pt_team_no_team_title = en_team_no_team_title;

/** @type {(inputs: Team_No_Team_TitleInputs) => LocalizedString} */
const ko_team_no_team_title = en_team_no_team_title;

/**
* | output |
* | --- |
* | "No Team Yet" |
*
* @param {Team_No_Team_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const team_no_team_title = /** @type {((inputs?: Team_No_Team_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_No_Team_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_team_no_team_title(inputs)
	if (locale === "es") return es_team_no_team_title(inputs)
	if (locale === "fr") return fr_team_no_team_title(inputs)
	if (locale === "de") return de_team_no_team_title(inputs)
	if (locale === "ja") return ja_team_no_team_title(inputs)
	if (locale === "zh") return zh_team_no_team_title(inputs)
	if (locale === "ar") return ar_team_no_team_title(inputs)
	if (locale === "id") return id_team_no_team_title(inputs)
	if (locale === "it") return it_team_no_team_title(inputs)
	if (locale === "ru") return ru_team_no_team_title(inputs)
	if (locale === "pt") return pt_team_no_team_title(inputs)
	return ko_team_no_team_title(inputs)
});